import * as React from "react";
import { createStyles, Dialog, DialogTitle, makeStyles, Theme } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import ReactLoading from "react-loading";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingTitle: {
      flex: "0 0 auto",
      marginTop: "15px",
      padding: " 0px 25px",
    },
    loadingContent: {
      padding: "0px",
    },
    loading: {
      margin: "0 auto"
    }
  })
);

interface Props {
  titulo: string;
  abierto: boolean;
}

const LoadingDialog = ({ abierto, titulo }: Props) => {
  const classes = useStyles();
  return (
    <>
      <Dialog open={true} maxWidth="sm" fullWidth={false}>
        <DialogTitle className={classes.loadingTitle}>{titulo}</DialogTitle>
        <DialogContent className={classes.loadingContent}>
          <ReactLoading type="balls" color="#19754e" height={110} width={100} className={classes.loading} />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default LoadingDialog;
